<template>
    <el-dialog v-model="show"
    :close-on-click-modal="false"
    width="418px"
    :show-close="false"
    class="login-dialog">
    <template #header>
        <div class="login_header flexMainXcenter justify-between">
            <div class="login_back_box">
                <div class="flexMainXcenter point" v-if="showBackBtn" @click.stop="backHandle">
                    <img class="back_icon" src="@/assets/images/login/back_icon.png" alt="">
                    <div class="back_txt">返回</div>
                </div>
            </div>
            <div class="close_box" @click='closeLoginModel'>
                <img src="@/assets/images/dialog/close.png" alt="">
            </div>
        </div>
    </template>
    <div class="form_body">
        <component 
            :is="forms[form]" 
            @to="to"
            :hasAgreement="showAgreement"
            :isForgetPwd="isForgetPwd"
            :ctxPhoneZone="phoneZone"
            :ctxPhoneNumber="phoneNumber"
            :ctxAgreementCheckOut="agreementCheckOut"
            :nexSetingShow="nexSetingShow"
            @onLoginSuccess="onLoginSuccess"
            @closeDialog="closeDialog"
            @focus="focusHandle"
            @blur="blurHandle"
            />
    </div>
    <template #footer>
        <agreementCheck v-if="showAgreement" :ctxAgreementCheckOut="agreementCheckOut"/>
    </template>
    </el-dialog>
</template>

<script setup>
    import { ref,onMounted } from 'vue'
    import { useLoginStore } from './store';
    import { storeToRefs } from "pinia";
    import { encryptPhoneNumber } from '@/utils/public'
    import requestApi from "@/api/index";
    import agreementCheck from "./agreementCheck.vue"; //底部协议
    import VccLoginForm from './VccLoginForm.vue'; //验证码登录/绑定手机
    import PwdLoginForm from './PwdLoginForm.vue'; //密码登录
    import AccountAppeal from './accountAppeal.vue'; //账号申诉
    import PwdSettingForm from './PwdSettingForm.vue'; //设置/更改密码
    import VccCheckForm from './VccCheckForm.vue'; //手机验证    
    import { useUserStore } from '@/store';
    import { useEditModuleStore } from '@/store/modules/editModule'

  
    const emits = defineEmits(['closeLoginDialog','successLogin'])
    const store = useUserStore();
    const editModuleStore = useEditModuleStore()
    const loginStore = useLoginStore();
    const {phoneZone,phoneNumber,agreementCheckOut} = storeToRefs(loginStore);
    const show = ref(true); //dialog显示
    const showBackBtn = ref(false); //是否显示返回按钮
    const showAgreement = ref(false); //是否显示协议
    const isForgetPwd = ref(false); //是否是忘记密码
    const nexSetingShow = ref(false); //是否显示下次设置
    const form = ref(""); //当前模块
    const history = []; //历史列表
    const forms = { //组件
        VccLoginForm,
        PwdLoginForm,
        AccountAppeal,
        PwdSettingForm,
        VccCheckForm
    }
    const hasBackList = [
        {
            // 忘记密码hasBack:true,hasAgreement:false,isForgetPwd:true
            // 绑定手机号hasBack:false,hasAgreement:false,isForgetPwd:false
            // 验证码登录hasBack:false,hasAgreement:true,isForgetPwd:false
            model: 'VccLoginForm',//验证码登录/绑定手机
            hasBack: false,
            hasAgreement: true, //true是验证码登录，false绑定手机号/忘记密码
            isForgetPwd: false, //是否为忘记密码
        },
        {
            model: 'PwdLoginForm',//密码登录
            hasBack: false,
            hasAgreement: true
        },
        {
            model: 'AccountAppeal',//账号申诉
            hasBack: true,
            hasAgreement: false
        },
        {
            // 设置密码hasback:false,hasAgreement:true
            // 更改密码hasBack:true,hasAgreement:false
            model: 'PwdSettingForm',//设置/更改密码
            hasBack: false, // 更改密码为true,设置密码为false
            hasAgreement: true,
            nexSetingShow: true
        },
        {
            model: 'VccCheckForm',//手机验证
            hasBack: true,
            hasAgreement: true
        }
    ]

    onMounted(()=>{
        dialogInit();
    })

    // 初始化
    const dialogInit = () => {
        form.value = "VccLoginForm";
        hasBackList.map((e)=>{
            if(e.model == form.value){
                console.log('是的')
                showBackBtn.value = e.hasBack;
                showAgreement.value = e.hasAgreement;
                if(e.model == 'VccLoginForm'){
                    isForgetPwd.value = e.isForgetPwd;
                }
            }
        })
    }

    // 登录成功
    const onLoginSuccess = (item,phone,zoneNum,checkDefault,removeDefault) => {
        store.$patch({
            access: item,
            phoneNumber: phone,
            zoneNum: zoneNum,
            encryptionPhone: encryptPhoneNumber(phone)
        });
        store.getUserinfo(phone);
        if(removeDefault){ //去掉defalult
            store.$patch({
                defaultUser: false
            })
        }
        if(checkDefault){
            isDefaultUser();
        }else{
            setTimeout(()=>{
                show.value = false;
                emits('closeLoginDialog')
                location.reload();
            },500)
        }
        
    }

    // 确认是否为默认用户
    const isDefaultUser = () =>{
        requestApi.loginModule.checkDefaultUser().then((res)=>{
            const result = res.data;
            console.log('isDefaultUser',result)
            if(result.code == 200){
                if(!result.data){
                    setTimeout(()=>{
                        show.value = false;
                        emits('closeLoginDialog')
                        location.reload();
                    },500)
                }else{
                    store.$patch({
                        defaultUser: true
                    });
                    to({
                        model:'PwdSettingForm', 
                        hasBack:false, 
                        hasAgreement:true,
                        isForgetPwd: false,
                        nexSetingShow: true
                    })
                }
            }
        })
    }

    const closeDialog = (type) => {
        show.value = false;
        if(type){ //验证码登录设置完密码后清除defaultUser
            store.$patch({
                defaultUser: false
            });
        }
        emits('closeLoginDialog')
    }

    // 返回
    const backHandle = () => {
        if (history.length > 0) {
            console.log('235',history)
            form.value = history[0].model;
            showBackBtn.value = history[0].hasBack
            showAgreement.value = history[0].hasAgreement
            isForgetPwd.value = history[0].isForgetPwd
            history.shift();
        }
    }

    // 关闭弹窗
    const closeLoginModel = () => {
        show.value = false;
        loginStore.clearStoreData();
        if(nexSetingShow.value){
            location.reload();
        }
        setTimeout(()=>{
            emits('closeLoginDialog')
        },500)
    }

    // 切换路由
    const to = (item) => {
        phoneZone.value = loginStore.phoneZone
        phoneNumber.value = loginStore.phoneNumber
        agreementCheckOut.value = loginStore.agreementCheckOut
        if(item.hasBack){
            let obj = {
                model: form.value,
                hasBack: showBackBtn.value,
                hasAgreement: showAgreement.value,
                isForgetPwd: isForgetPwd.value,
                nexSetingShow: nexSetingShow.value
            }
            history.unshift(obj);
        }
        form.value = item.model;
        showBackBtn.value = item.hasBack;
        showAgreement.value = item.hasAgreement;
        isForgetPwd.value = item.isForgetPwd;
        nexSetingShow.value = item.nexSetingShow;
        console.log('tohistory',history)
    }

    // 
    const focusHandle = () =>{
        editModuleStore.setTextIsEditing(true)
    }
    // 
    const blurHandle = () =>{
        editModuleStore.setTextIsEditing(false)
    }
</script>

<style lang="scss" scoped>
    @import url(./styles/index.scss);
    .login_header{
        // padding: 24px 24px 16px;
        height: 20px;
        .login_back_box{
            cursor: pointer;
            min-width: 40px;
            .back_icon{
                width: 20px;
                height: 20px;
                margin-right: 4px;
            }
            .back_txt{
                color:#86909C;
                font-family: PingFang SC;
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                &:hover{
                    color:#4E5969;
                }
            }
        }
        .close_box{
            cursor: pointer;
            width: 20px;
            height: 20px;
            border-radius: 6px;
            
            img{
                width: 100%;
                height: 100%;
            }
            &:hover{
                background: #F2F3F5;
            }
        }
    }
    .form_body{
        padding-bottom: 74px;
    }
</style>